// extracted by mini-css-extract-plugin
export default {"root":"EditableText_root__3NVPw"};